import { gql } from "@apollo/client";

export const DELETE_PROJECT = gql`
  mutation deleteProject($pId: ID!, $cId: ID!) {
    DeleteProject(pId: $pId, cId: $cId) {
      message
      success
      result
    }
  }
`;
